<template>
  <div class="shopping-cart">
    <gaia-header @upload="$refs.dialog.show()" />
    <div style="height: 70px"></div>
    <div
      class="header"
      :class="{
        shoppingCartBackground: radio === 0,
        orderBackground: radio === 1,
        detailBackground: radio === 2,
      }"
    >
      <div
        class="logo"
        :class="{
          shoppingCartLogo: radio === 0,
          orderLogo: radio === 1,
          detailCartLogo: radio === 2,
        }"
      ></div>
      <div>{{ radioList[radio] }}</div>
      <div class="info">感谢您对Gaiamount原创视频的支持。</div>
    </div>
    <div class="page">
      <el-radio-group v-model="radio" size="mini" @change="pageRadioChange">
        <el-radio-button :label="0">
          <div class="radio-item">购物车</div>
        </el-radio-button>
        <el-radio-button :label="1">
          <div class="radio-item">订单中心</div>
        </el-radio-button>
        <el-radio-button :label="2">
          <div class="radio-item">收支明细</div>
        </el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-show="radio === 1 || radio === 2"
        v-model="time"
        @change="datePickerChange"
        value-format="timestamp"
        size="small"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        style="float: right"
      >
      </el-date-picker>
      <!-- <div
        v-if="shoppingList.length === 0"
        style="
          width: 100%;
          height: 500px;
          text-align: center;
          padding-top: 100px;
        "
      >
        暂无数据
      </div> -->
      <div v-if="radio === 0">
        <div class="box" v-loading="loading">
          <div class="list">
            <div
              v-if="!loading && shoppingList.length === 0"
              style="
                text-align: center;
                padding-top: 40px;
                font-size: 12px;
                color: #666666;
              "
            >
              暂无商品
            </div>
            <div class="item" v-for="(item, i) in shoppingList">
              <div>
                <el-checkbox
                  v-model="checkbox"
                  :label="item.id"
                  @change="(e) => itemCheckboxChange(e, item.id)"
                ></el-checkbox>
              </div>
              <div class="cover">
                <img :src="baseUrl + getCover(item)" @click="jumpTo(item)" />
              </div>
              <div class="info">
                <div class="title">{{ getTitle(item) }}</div>
                <div class="type">
                  {{ type2[item.contentType] || `${getMaterialType(item)}` }}
                </div>
                <div class="video-info">{{ getVideoInfo(item) }}</div>
              </div>
              <div
                class="obj-price"
                :style="{
                  visibility:
                    getFirstPrice(item) != getPrice(item) ? 'none' : 'hidden',
                }"
              >
                ¥{{ getFirstPrice(item) }}
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="price">¥{{ getPrice(item) }}</div>
              <div class="close">
                <i class="el-icon-close" @click="close(item)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="checkbox">
          <el-checkbox v-model="selectAll" @change="selectAllChange">
            全选
          </el-checkbox>
          <div class="info">
            <div class="title">
              <div>合计</div>
              <div>数量</div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="content">
              <div>¥{{ buttonPrice.toFixed(2) }}</div>
              <div>{{ checkbox.length }}</div>
            </div>
          </div>
          <div class="pay">
            <span style="font-size: 12px; color: #999; margin-right: 20px">
              支付
            </span>
            <el-button
              :loading="payLoading"
              type="primary"
              style="width: 144px"
              @click="createPay"
            >
              ¥{{ buttonPrice.toFixed(2) }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- <div
        v-if="radio === 1"
        v-loading="loading"
        class="box"
        style="min-height: 100px"
      >
        1
      </div> -->

      <div
        v-if="radio === 1"
        v-loading="loading"
        style="min-height: 100px; margin: 30px 0"
      >
        <div class="order-item box" v-for="(item, i) in orderFormList">
          <div class="date">
            {{ $dayjs(item.createTime).format("YYYY.MM.DD") }}
          </div>
          <div class="time">
            {{ $dayjs(item.createTime).format("hh:mm:ss") }}
          </div>
          <div class="id">
            <span style="margin-right: 800px"> 订单号：{{ item.id }} </span>
            <span
              v-if="isExpired(item.createTime) && item.state === 'unpaid'"
              style="color: #ff464c"
            >
              <span style="margin-right: 10px; font-size: 16px">
                <i class="el-icon-alarm-clock"> </i>
              </span>
              <span class="time" style="color: #ff464c">{{
                getCountDown(item.createTime)
              }}</span>
            </span>
            <span v-if="!isExpired(item.createTime) && item.state === 'unpaid'">
              该订单已取消
            </span>
            <span v-if="item.state === 'paid'"> 该订单已完成 </span>
          </div>
          <div
            class="item"
            v-for="(item2, i) in [
              ...item.courseSnapshots,
              ...item.materialSnapshots,
              ...item.worksSnapshots,
              ...(item.memberSnapshot ? [item.memberSnapshot] : []),
            ]"
          >
            <div class="cover">
              <img :src="baseUrl + getCover(item2)" @click="jumpTo(item2)" />
            </div>
            <div class="info">
              <div class="title" v-if="!item2.memberType">
                {{ item2.title }}
              </div>
              <div class="type">
                {{ type2[item2.contentType] || `${getMaterialType(item2)}` }}
              </div>
              <div class="video-info">{{ getVideoInfo(item2) }}</div>
            </div>
            <div
              class="obj-price"
              :style="{
                visibility:
                  getFirstPrice(item2) != (item2.price / 100).toFixed(2)
                    ? 'none'
                    : 'hidden',
              }"
            >
              ¥{{ getFirstPrice(item2) }}
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="price2 price">
              ¥{{ (item2.price / 100).toFixed(2) }}
            </div>
          </div>
          <div class="info">
            共
            <span style="font-weight: 700; color: #333333">
              {{
                item.materialSnapshots.length +
                item.worksSnapshots.length +
                item.courseSnapshots.length
              }}
            </span>
            项
            <span style="margin-right: 74%"></span>
            合计: ¥
            <span class="price">{{ getOrderPrice(item) }}</span>
            <el-button
              :disabled="item.state !== 'unpaid' || !isExpired(item.createTime)"
              type="primary"
              size="small"
              style="width: 100px"
            >
              <span
                v-if="item.state === 'unpaid' && isExpired(item.createTime)"
                @click="payAgain(item.id)"
              >
                立即支付
              </span>
              <span v-if="item.state === 'paid'">已完成</span>
              <span
                v-if="item.state === 'unpaid' && !isExpired(item.createTime)"
              >
                已超时
              </span>
              <span v-if="item.state === 'cancel'">交易已取消</span>
            </el-button>
          </div>
        </div>
      </div>
      <div
        v-if="radio === 2"
        v-loading="loading"
        style="min-height: 100px; margin: 30px 0"
      >
        <div class="expense-item box">
          <el-radio-group v-model="radio2" size="mini" @change="expenseChange">
            <el-radio-button :label="0">收入</el-radio-button>
            <el-radio-button :label="1">支出</el-radio-button>
          </el-radio-group>
          <div class="item" v-for="(item, i) in expenseList">
            <div class="index">{{ i + 1 }}</div>
            <div class="info">
              <div class="info-item">
                <div class="name">{{ item.title }}</div>
                <div class="id">ID：{{ item.id }}</div>
              </div>
              <div class="info-item">
                <div class="name">类型：{{ item.title }}</div>
                <div class="id">格式：{{ item.id }}</div>
              </div>
              <div class="info-item">
                <div class="name">
                  交易时间：{{
                    $dayjs(item.createTime).format("YYYY/MM/DD hh:mm:ss")
                  }}
                </div>
                <div class="id">单号：{{ item.orderId }}</div>
              </div>
            </div>
            <div>
              收款帐户:
              <span v-if="item.bankName">
                {{ item.bankName }}<br />
                ({{ getStarText(item.bankCard) }})
              </span>
              <span v-else> 支付宝 </span>
            </div>
            <div style="margin-left: 60px">
              <div>
                金额：
                <span style="color: #096">{{
                  (item.price / 100).toFixed(2)
                }}</span>
              </div>
              <div>
                状态：
                <span style="color: #ff7f00">
                  {{ item.state === "processing" ? "处理中" : "已完成" }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gaia-footer />
  </div>
</template>

<script>
import gaiaHeader from "@/components/gaia-header/gaia-header";
import GaiaFooter from "@/components/gaia-footer/gaia-footer";
import {
  getWorksShoppingCartList,
  getCollegeShoppingCartList,
  getOrderShoppingCartList,
  getShoppingCartList,
  collegeShopDelete,
  worksShopDelete,
  materialShopDelete,
  memberDelete,
  createPay,
  getOrderList,
  payAgain,
  getIncomeList,
  getExpenseList,
} from "@/api/order";
export default {
  components: {
    gaiaHeader,
    GaiaFooter,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      radio: 0,
      radio2: 0,
      radioList: ["购物车", "订单中心", "收支明细"],
      page: {
        pageIndex: 1,
        pageSize: 100,
      },
      shoppingList: [],
      checkbox: [],
      type2: {
        video: "学院教程",
        imgAndText: "学院教程",
        hdr: "视频播放",
        show: "视频播放",
        works: "视频播放",
      },
      loading: false,
      selectAll: false,
      buttonPrice: 0,
      payLoading: false,
      orderFormList: [],
      IncomeList: [],
      expenseList: [],
      time: [new Date().getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
    };
  },
  created() {
    this.getShoppingCart();
    setInterval(() => {
      if (this.radio === 1) {
        this.$forceUpdate();
      }
    }, 1000);
  },
  methods: {
    jumpTo(item) {
      if (item.materialSnapshots) {
        const material = item.materialSnapshots;
        if (material.contentType.includes("material")) {
          const id = material.id;
          const contentType = material.contentType;
        }
      } else {
        if (item.contentType.includes("material")) {
          // 跳转素材
          const id = item.material.id;
          const contentType = item.material.contentType;
          this.$router.push(
            `/gaia-material/detail/${id}?contentType=${contentType}`
          );
        }
      }
    },
    datePickerChange() {
      if (this.radio === 1) {
        this.getOrderList();
      }
      if (this.radio === 2) {
        this.expenseChange();
      }
    },
    getStarText(val) {
      if (!val) {
        return val;
      }
      return `${val.substring(0, 4)}****${val.substring(
        val.length - 4,
        val.length
      )}`;
    },
    expenseChange() {
      if (this.radio2 === 0) {
        this.getIncomeList();
      } else {
        this.getExpenseList();
      }
    },
    pageRadioChange() {
      if (this.radio === 0) {
        this.getShoppingCart();
      }
      if (this.radio === 1) {
        this.getOrderList();
      }
      if (this.radio === 2) {
        this.expenseChange();
      }
    },
    getCover(data) {
      if (!data) {
        return "";
      }
      let cover = data.cover;
      let isMaterial = data.material;
      let isMember = data.memberType;
      if (isMaterial) {
        if (!data.material.cover) {
          data.material.video.resources.map((el) => {
            if (el.resourceName === "180") {
              cover = el.resourceKey;
            }
          });
        } else {
          cover = data.material.cover;
        }
      } else if (isMember) {
        if (data.memberType === "pro") {
          cover = "/web/img/pro_member.png";
        } else if (data.memberType === "adv") {
          cover = "/web/img/adv_member.png";
        } else if (data.memberType === "bns") {
          cover = "/web/img/bns_member.png";
        }
      } else if (data.screenshot) {
        cover = data.screenshot;
      }
      return cover;
    },
    getTitle(data) {
      if (data.name) {
        return data.name;
      } else if (data.memberType) {
        const obj = {
          pro: "专业会员",
          adv: "高级会员",
          bns: "商业会员",
        };
        return obj[data.memberType];
      }
      return data.material.title;
    },
    getMaterialType(data) {
      if (data.memberType) {
        const obj = {
          pro: "专业会员",
          adv: "高级会员",
          bns: "商业会员",
        };
        return obj[data.memberType];
      }
      if (
        data.priceLevel &&
        data.priceLevel.toLocaleLowerCase().includes("transcode")
      ) {
        return `素材转码${data.priceLevel
          .replace("transcode", "")
          .replace("disTranscode", "")}`;
      }
      return "素材源文件";
    },
    getVideoInfo(data) {
      if (["video", "hdr", "show"].includes(data.contentType) && data.works) {
        const videoInfo = data.works.video.videoInfo;
        const formatInfo = data.works.video.formatInfo;
        return `${videoInfo.width}×${videoInfo.height} ${
          formatInfo.extension
        } ${videoInfo.codecDisplayName} ${(
          formatInfo.bitRate /
          1024 /
          1024
        ).toFixed(2)} Mbps ${videoInfo.fps.toFixed(2)}FPS`;
      }
      if (data.memberType) {
        const obj = {
          pro: "6GB/周 300GB/年",
          adv: "6GB/周 300GB/年",
          bns: "6GB/周 300GB/年",
        };
        return obj[data.memberType];
      }
    },
    getPrice(data) {
      if (data.memberType) {
        const obj = {
          pro: "360.00",
          adv: "1380.00",
          bns: "3600.00",
        };
        return obj[data.memberType];
      }
      if (data.disPlayPrice !== undefined) {
        return (data.disPlayPrice / 100).toFixed(2);
      }
      // 素材价格
      // 视频素材
      if (data.material && data.material.mworks) {
        if (data.priceLevel.toLocaleLowerCase().includes("transcode")) {
          return (
            data.material.mworks[`${data.priceLevel}Price`] / 100
          ).toFixed(2);
        }
        return (data.material[`${data.priceLevel}Price`] / 100).toFixed(2);
      }
      // 其它素材
      return (data.material[`${data.priceLevel}Price`] / 100).toFixed(2);
    },
    getFirstPrice(data) {
      if (data && data.firstPrice !== undefined) {
        return (data.firstPrice / 100).toFixed(2);
      }
      if (data.material) {
        return (data.material.firstPrice / 100).toFixed(2);
      }
      if (data.course) {
        return (data.course.firstPrice / 100).toFixed(2);
      }
      if (data.works) {
        return (data.works.firstPrice / 100).toFixed(2);
      }
      return this.getPrice(data);
    },
    close(data) {
      this.$confirm("确认删除？")
        .then((_) => {
          const id = data.id;
          this.loading = true;
          if (data.course) {
            collegeShopDelete(id)
              .then((res) => {
                this.$message.success("删除成功");
                this.getShoppingCart();
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败");
              });
          } else if (data.works) {
            worksShopDelete(id)
              .then((res) => {
                this.$message.success("删除成功");
                this.getShoppingCart();
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败");
              });
          } else if (data.material) {
            materialShopDelete(id)
              .then((res) => {
                this.$message.success("删除成功");
                this.getShoppingCart();
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败");
              });
          } else if (data.memberType) {
            memberDelete()
              .then((res) => {
                this.$message.success("删除成功");
                this.getShoppingCart();
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败");
              });
          } else {
            this.loading = false;
            this.$message.error("删除失败");
          }
        })
        .catch((_) => {});
    },
    selectAllChange(bool) {
      if (bool) {
        this.checkbox = this.shoppingList.map((el) => {
          return el.id;
        });
      } else {
        this.checkbox = [];
      }
      this.buttonPrice = this.getSelectPrice();
    },
    itemCheckboxChange(e, id) {
      this.buttonPrice = this.getSelectPrice();
    },
    getSelectPrice() {
      let price = 0;
      this.checkbox.map((id) => {
        this.shoppingList.map((el) => {
          if (el.id == id) {
            price += Number(this.getPrice(el));
          }
        });
      });
      return price;
    },
    createPay() {
      if (this.checkbox.length === 0) {
        this.$message.error("请至少勾选一个商品进行结算");
        return;
      }
      this.payLoading = true;
      let data = {
        courseShoppingCartIds: [],
        worksShoppingCartIds: [],
        materialShoppingCartIds: [],
        isMobile: false,
        memberPay: false,
        payment: "alipay",
      };
      this.checkbox.map((id) => {
        this.shoppingList.map((el) => {
          if (el.id == id) {
            if (el.course) {
              data.courseShoppingCartIds.push(id);
            } else if (el.works) {
              data.worksShoppingCartIds.push(id);
            } else if (el.material) {
              data.materialShoppingCartIds.push(id);
            } else if (el.memberType) {
              data.memberPay = true;
            }
          }
        });
      });
      createPay(data)
        .then((res) => {
          console.log(res);
          this.payLoading = false;
          if (res.form) {
            this.$message.success("订单创建成功, 即将跳转到支付页面");
            setTimeout(() => {
              document.write(res.form);
            }, 1000);
          }
        })
        .catch((err) => {
          console.log(err);
          this.payLoading = false;
        });
    },
    getShoppingCart() {
      this.loading = true;
      const order = new Promise((resolve) => {
        getOrderShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const works = new Promise((resolve) => {
        getWorksShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const college = new Promise((resolve) => {
        getCollegeShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const material = new Promise((resolve) => {
        getShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      Promise.all([order, works, college, material])
        .then((res) => {
          const order = res[0].memberShoppingCart;
          const works = res[1].worksShoppingCartBOS;
          const college = res[2].courseShoppingCartBOS;
          const material = res[3].materialShoppingCarts;
          this.shoppingList = [];
          if (order) {
            this.shoppingList.push(order);
          }
          if (college) {
            college.map((el) => {
              this.shoppingList.push(el);
            });
          }
          if (works) {
            works.map((el) => {
              this.shoppingList.push(el);
            });
          }
          if (material) {
            material.map((el) => {
              this.shoppingList.push(el);
            });
          }
          // 冒泡排序, 根据添加时间排序
          const list = this.shoppingList;
          for (let j = 0; j < list.length; j++) {
            let done = true;
            let max = list.length - 1;
            for (let i = 0; i < max - j; i++) {
              if (
                new Date(list[i].createTime).valueOf() <
                new Date(list[i + 1].createTime).valueOf()
              ) {
                let temp = list[i];
                list[i] = list[i + 1];
                list[i + 1] = temp;
                done = false;
              }
            }
            if (done) {
              break;
            }
          }
          list.map((el, i) => {
            if (el.works) {
              list[i].name = el.works.title;
              if (el.works.cover) {
                list[i].cover = el.works.cover;
              } else {
                el.works.video.resources.map((el) => {
                  if (el.resourceKey && el.resourceKey.includes("180.png")) {
                    list[i].cover = el.resourceKey;
                  }
                });
              }
            } else if (el.course) {
              list[i].name = el.course.title;
              list[i].cover = el.course.cover;
            }
          });
          // log(JSON.parse(JSON.stringify(list)));
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    getOrderList() {
      this.orderFormList = [];
      this.loading = true;
      const data = {
        startTime: this.time ? this.time[0] : 0,
        endTime: this.time ? this.time[1] : 0,
        pageIndex: 1,
        pageSize: 1000,
      };
      getOrderList(data)
        .then((res) => {
          console.log(res);
          this.orderFormList = res.orderFormList;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    getOrderPrice(data) {
      let price = 0;
      data.courseSnapshots.map((el) => {
        price += el.price;
      });
      data.materialSnapshots.map((el) => {
        price += el.price;
      });
      data.worksSnapshots.map((el) => {
        price += el.price;
      });
      if (data.memberSnapshot) {
        price += data.memberSnapshot.price;
      }
      return (price / 100).toFixed(2);
    },
    isExpired(time) {
      let add10 = this.$dayjs(time).add(10, "minutes").valueOf();
      let now = this.$dayjs(new Date()).valueOf();
      return Number(add10 - now) > 0;
    },
    payAgain(id) {
      payAgain(id)
        .then((res) => {
          console.log(res);
          document.write(res.form);
        })
        .catch((err) => {
          this.$message.error("支付错误");
          console.log(err);
        });
    },
    getCountDown(time) {
      let add10 = this.$dayjs(time).add(10, "minutes").valueOf();
      let now = this.$dayjs(new Date()).valueOf();
      return this.$dayjs(add10 - now).format("mm:ss");
    },
    getOrderDetailList(data) {
      // if(data.)
    },
    getExpenseList() {
      this.loading = true;
      const data = {
        startTime: this.time ? this.time[0] : 0,
        endTime: this.time ? this.time[1] : 0,
        pageIndex: 1,
        pageSize: 20,
        contentType: "",
      };
      getExpenseList(data)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.expenseList = res.expenseList;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getIncomeList() {
      this.loading = true;
      const data = {
        startTime: this.time ? this.time[0] : 0,
        endTime: this.time ? this.time[1] : 0,
        pageIndex: 1,
        pageSize: 20,
        contentType: "",
      };
      getIncomeList(data)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.expenseList = res.incomeList;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less">
.shopping-cart {
  .box {
    .el-checkbox__label {
      display: none;
    }
  }
}
</style>
<style lang="less" scoped>
.shopping-cart {
  min-width: 1300px;
  background: #ebebeb;
}
.header {
  height: 240px;
  // margin-bottom: 40px;
  padding: 50px 0;
  color: #ffffff;
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 40px;
  text-align: center;
  box-sizing: border-box;
  .logo {
    height: 70px;
  }
  .info {
    font-size: 13px;
    font-weight: 400;
    margin-top: 20px;
    text-shadow: 0.707px 0.707px 0 rgba(0, 0, 0, 0.1);
  }
}
.shoppingCartBackground {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/balance-bg.png);
}
.orderBackground {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/order-center-bg.png);
}
.detailBackground {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/cart-bg.png);
}
.shoppingCartLogo {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/Cart%20Icon.png);
}
.orderLogo {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/Document%20Text%20Icon.png);
}
.detailCartLogo {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/Calendar%20Icon.png);
}
.shoppingCartLogo,
.orderLogo,
.detailCartLogo {
  display: inline-block;
  width: 71px;
  margin: 0 auto;
  background-repeat: no-repeat;
}
.radio-item {
  width: 71px;
  font-size: 14px;
  font-weight: 700;
}
.box {
  width: 100%;
  min-height: 100px;
  background: #ffffff;
  margin: 20px 0;
  border-radius: 4px;
}
.list {
  margin-top: 30px;
  padding-bottom: 20px;
}
.item {
  display: flex;
  align-items: center;
  padding: 20px 60px 20px 20px;
  .el-checkbox {
    margin: 0 20px;
  }
  .cover {
    width: 14%;
    height: 100px;
    padding-top: 10px;
    object-fit: cover;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
  .info {
    width: 60%;
    height: 100%;
    padding: 0px 20px;
    .title {
      font-size: 14px;
      font-weight: 700;
      color: #333333;
    }
    .type {
      font-size: 12px;
      font-weight: 700;
      color: #ff464c;
      margin: 14px 0;
    }
    .video-info {
      font-size: 12px;
      color: #999;
      margin-right: 5px;
    }
  }
  .obj-price,
  .price {
    width: 10%;
    color: #333333;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
  }
  .obj-price {
    color: #999999;
    text-decoration: line-through;
    font-size: 14px;
  }
  .close {
    color: #aaaaaa;
    i {
      cursor: pointer;
    }
    i:hover {
      color: #cccccc;
    }
  }
}
.checkbox {
  margin: 80px 0 100px;
  padding-bottom: 50px;
  .info {
    width: 200px;
    float: right;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
    .title,
    .content {
      display: inline-block;
    }
    .content {
      width: 150px;
      color: #333333;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      text-align: right;
    }
  }
}
.pay {
  position: relative;
  display: inline-block;
  top: 60px;
  left: 79%;
}
.order-item {
  margin: 20px 0;
  padding: 40px;
  .date,
  .time {
    display: inline-block;
  }
  .date {
    font-weight: bold;
    color: #333;
    font-size: 20px;
    margin-right: 10px;
    font-weight: 700;
  }
  .time,
  .id {
    font-size: 12px;
    font-weight: 700;
    color: #999;
  }
  .id {
    margin: 20px 0;
  }
  .info {
    font-size: 12px;
    color: #999;
  }
  .price {
    font-size: 18px;
    margin-right: 10px;
    color: #ff464c;
  }
}
.price2 {
  font-size: 14px;
  color: #333333;
}
.expense-item {
  padding: 10px 40px;
  color: #999999;
  font-weight: 400;
  font-size: 12px;
  .item {
    display: flex;
    .index {
      width: 1%;
    }
    .info {
      width: 73%;
      display: flex;
      font-size: 12px;
      .info-item {
        width: 33%;
        text-align: left;
      }
    }
  }
}
</style>